import { render, staticRenderFns } from "./TagAddNew.vue?vue&type=template&id=67d54af2&"
import script from "./TagAddNew.vue?vue&type=script&lang=js&"
export * from "./TagAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports